export const hproduce = {
  name: 'HProduce',
  url: {
    qa: 'https://qa.hproduce.digital',
    uat: 'https://uat.hproduce.digital',
    prod: 'https://hproduce.digital'
  }
}

// Route for plant performance page
export const PLANT_KPI = '/performance/plant/:plantId'

export const STATUS = '/status'
